import { createContext, useContext, useState, ReactNode } from 'react'

interface TaskPanelContextType {
  isOpen: boolean
  openPanel: () => void
  closePanel: () => void
  togglePanel: () => void
  unreadCount: number
  setUnreadCount: (count: number) => void
}

const TaskPanelContext = createContext<TaskPanelContextType | undefined>(undefined)

export function TaskPanelProvider({ children }: { children: ReactNode }) {
  const TASK_PANEL_VISIBLE_KEY = 'clnicl_task_panel_visible'
  
  const [isOpen, setIsOpenState] = useState(() => {
    const saved = localStorage.getItem(TASK_PANEL_VISIBLE_KEY)
    return saved !== null ? saved === 'true' : false
  })

  const [unreadCount, setUnreadCountState] = useState(0)

  const setIsOpen = (open: boolean) => {
    setIsOpenState(open)
    localStorage.setItem(TASK_PANEL_VISIBLE_KEY, String(open))
  }

  const openPanel = () => setIsOpen(true)
  const closePanel = () => setIsOpen(false)
  const togglePanel = () => setIsOpen(!isOpen)

  const setUnreadCount = (count: number) => {
    setUnreadCountState(count)
  }

  return (
    <TaskPanelContext.Provider
      value={{
        isOpen,
        openPanel,
        closePanel,
        togglePanel,
        unreadCount,
        setUnreadCount,
      }}
    >
      {children}
    </TaskPanelContext.Provider>
  )
}

export function useTaskPanel() {
  const context = useContext(TaskPanelContext)
  if (context === undefined) {
    throw new Error('useTaskPanel must be used within a TaskPanelProvider')
  }
  return context
}
































